import { render, staticRenderFns } from "./InstrumentIdentificationForm.vue?vue&type=template&id=33715840"
import script from "./InstrumentIdentificationForm.vue?vue&type=script&lang=js"
export * from "./InstrumentIdentificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports